import { render, staticRenderFns } from "./UseDialog.vue?vue&type=template&id=7e8bb952&scoped=true&"
import script from "./UseDialog.vue?vue&type=script&lang=js&"
export * from "./UseDialog.vue?vue&type=script&lang=js&"
import style0 from "./UseDialog.vue?vue&type=style&index=0&id=7e8bb952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8bb952",
  null
  
)

export default component.exports